export default __webpack_public_path__ + "assets/ms-icon-70x70.ccc3f3c7509b513d084793b6a6a6a853.png";